import { render, staticRenderFns } from "./onBindEmail.vue?vue&type=template&id=19fd3254&scoped=true"
import script from "./onBindEmail.vue?vue&type=script&lang=ts"
export * from "./onBindEmail.vue?vue&type=script&lang=ts"
import style0 from "./onBindEmail.vue?vue&type=style&index=0&id=19fd3254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd3254",
  null
  
)

export default component.exports